import Styles from './ReviewTemplates.module.scss'
import { Button } from 'components/Button'
import { useNewReviewTemplateModalProps } from 'components/ReviewTemplateFormModal/useNewReviewTemplateModalProps'
import { NewReviewTemplateFormModal } from 'components/ReviewTemplateFormModal/NewReviewTemplateFormModal'
import { useModals } from 'almanac-ui/Modal'
import { ReviewTemplates } from 'almanac-ui/icons/24'

export const ColdState = () => {
  const { onSubmit } = useNewReviewTemplateModalProps()
  const { openModal } = useModals()

  const openReviewTemplateFormModal = () =>
    openModal(NewReviewTemplateFormModal, {
      onSubmit,
    })

  return (
    <div className={Styles.container}>
      <div className={Styles.coldState}>
        <div className={Styles.icon}>
          <ReviewTemplates />
        </div>
        <div className={Styles.coldStateTitle}>Create templates for your reviews</div>
        <div className={Styles.coldStateText}>
          Templates can include reviewers, a due date or a message and are available to all members.
        </div>
        <Button variant="secondary" size="lg" onPress={openReviewTemplateFormModal}>
          Create Review Template
        </Button>
      </div>
    </div>
  )
}
